import { render } from "./Organizations.vue?vue&type=template&id=2d68978b"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"

import "./Organizations.vue?vue&type=style&index=0&id=2d68978b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Organizations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d68978b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d68978b', __exports__)) {
    api.reload('2d68978b', __exports__)
  }
  
  module.hot.accept("./Organizations.vue?vue&type=template&id=2d68978b", () => {
    api.rerender('2d68978b', render)
  })

}


export default __exports__